import "./Navbar.css";
import { useState, useEffect } from "react";
import logo from "../assets/cashforgoldlogo.webp"; // ✅ IMPORT

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar ${scroll ? "scrolled" : ""}`}>
      <div className="nav-container">

        {/* LOGO */}
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        {/* NAV LINKS */}
        <ul className={`nav-links ${open ? "active" : ""}`}>
          <li><a href="#home" onClick={() => setOpen(false)}>Home</a></li>
          <li><a href="#about" onClick={() => setOpen(false)}>About</a></li>
          <li><a href="#services" onClick={() => setOpen(false)}>Services</a></li>
          <li><a href="#contact" onClick={() => setOpen(false)}>Contact</a></li>
          <li><a href="#blog" onClick={() => setOpen(false)}>Blog</a></li>
        </ul>

        {/* BUTTON */}
        <a href="#contact" className="call-btn">Call Now</a>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
    </header>
  );
}